import React from "react"

type Props = {
    onClick: void => void
}

const AddEvidenceButton = ({ onClick }: Props) => (
    <button
        className="add-evidence-button"
        onClick={onClick}
        data-cy="addEvidenceURLButton"
    >
        <div className="add-evidence-plus">+</div>
        <span className="add-evidence-text">Add Evidence</span>
    </button>
)

export default AddEvidenceButton
